import utils from 'utils'
import inforConfirmPage from './view/inforConfirm.html'
import angular from 'angular'
import authenticationModalTemplate from '../../../../../main/common/authenticationModalList.html'
import certificationModalTemplate from '../../../../../main/common/certificationModalList.html'
export default function inforConfirm($uibModal, httpRequest, logger, inforConfirmFieldConfig, $stateParams, $state, sweetalert) {
    return {
        restrict: 'E',
        scope: {
            confirmSheetState: '<',
            selectItem: '<',
            changeState: '=',
        },
        template: inforConfirmPage,
        controller: [
            '$scope',
            '$location',
            'initSortService',
            'composeService',
            'dictService',
            '$uibModal',
            'globalFn',
            ($scope, $location, initSortService, composeService, dictService, $uibModal, globalFn ) => {
                $scope.ukeyList = JSON.parse(localStorage.getItem('user_info')).tax4UkeyList
                $scope.dictData = {}
                const types = ['red_confirm_red_reason','vat_usage_code','excise_usage_code','entry_status']
                httpRequest.get_dictByTypeArr(types).then((res) => {
                    $scope.dictData = $.extend($scope.dictData, res.data.value)
                })
                $scope.isAdd = true // 初始化 不可新增 商品明细行
                $scope.isDel = false // 初始化 不可删除 商品明细行
                $scope.isEdit = false //初始化 不可编辑 商品明细行 金额
                $scope.isQuantity = false ////初始化 不可编辑 商品明细行 数量
                $scope.isEditReduction = false ////初始化 编辑时还原按钮 不展示
                $scope.isAddReduction = false ////初始化 新增时还原按钮 不展示
                $scope.approveStatu = false // 是否开启审批流
                httpRequest.post_qryFlowIsValid({ approveCode: 'tax4_red_comfirm_approve' }).then((res) => {
                    $scope.approveStatu = res.data.value
                })
                function queryList() {
                    $scope.newConfirmId = ''
                    if($stateParams.confirmId && !$scope.selectItem.confirmId){
                        console.log('编辑')
                        $scope.isEditReduction = true
                        $scope.newConfirmId = $stateParams.confirmId
                    }
                    if(!$stateParams.confirmId || ($stateParams.confirmId && $scope.selectItem.confirmId)){
                        console.log('新增')
                        $scope.isAddReduction = true
                        $scope.newConfirmId = $scope.selectItem.confirmId
                    }
                    httpRequest.post_getRedConfirmBody({confirmId:$scope.newConfirmId}).then((res) => {
                        $scope.invoice = res.data.value
                        $scope.invoice.ukeyId = $scope.selectItem.ukeyId?$scope.selectItem.ukeyId:res.data.value.ukeyId
                        $scope.dataList = $scope.invoice.ovatTax4RedConfirmDetails
                        dataFormat()
                    })
                }
                queryList()
                function dataFormat(){
                    let data = {
                        electricInvoiceNum: $scope.invoice.blueElectricInvoiceNum,
                        // confirmId:$scope.invoice.confirmId,
                        type:'red_confirm_red_reason',
                    }
                    httpRequest.post_getReasonDictionary(data).then((res) => {
                        $scope.dictData.red_confirm_red_reason =  res.data.value
                    })
                    $scope.invoice.redReason = $scope.invoice.redReason?$scope.invoice.redReason:'2'
                    $scope.invoice.isTax = $scope.invoice.isTax?Number($scope.invoice.isTax):0
                    totalCalculation($scope.dataList)
                    $scope.changeRedReason()
                }
                //记录修改前的 数量，含税单价，不含税单价，含税金额，不含税金额，税率
                let prevData = {
                    quantity: '',
                    price: '',
                    priceIncludeTax: '',
                    taxRate: '',
                    amount: '',
                    amountIncludeTax: '',
                    taxAmount: '',
                }
                $scope.getPrevData = function (item) {
                    prevData.quantity = item.quantity
                    prevData.price = item.price
                    prevData.priceIncludeTax = item.priceIncludeTax
                    prevData.taxRate = item.taxRate
                    prevData.amount = item.amount
                    prevData.amountIncludeTax = item.amountIncludeTax
                    prevData.taxAmount = item.taxAmount
                }
                // 是否正确的金额
                function isAmount(v) {
                    const reg_je = /^\-\d{1,12}(\.\d{0,2})?$/ // 金额规则 数字，小数点前12位，后2位
                    return globalFn.isNegativeFloatNum(v) && parseFloat(v) !== 0 && reg_je.test(v)
                }
                function isPriceSetable(price) {
                    if (/^\d{1,11}(\.\d{0,15})?$/.test(price) || !price) {
                        return true
                    }
                    return false
                }
                // 限制输入两位小数
                $scope.limitTwoDecimal = (obj, attr) => {
                    obj[attr] = obj[attr].replace(/[^\d.\.-]/g, '')
                    obj[attr] = obj[attr].replace(/^\./g, '')
                    obj[attr] = obj[attr].replace(/\.{2,}/g, '.').replace(/\-{2,}/g, '-')
                    obj[attr] = obj[attr].replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-')
                    obj[attr] = obj[attr].replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
                }
                function isAmountSetable(amount, isRed) {
                    // 可以不输入，如果放开限制，将不能清空输入框
                    if (!amount || (!isRed && /^\d{1,11}(\.\d{0,2})?$/.test(amount)) || (isRed && /^-\d{0,12}(\.\d{0,2})?$/.test(amount))) {
                        return true
                    }
                    return false
                }
                // 校验合计的商品金额 是否超过原始值
                function isOverOriginalValue() {
                    for(let i=0; i<$scope.dataList.length;i++){
                        if (Math.abs($scope.dataList[i].amount * 1) > Math.abs($scope.dataList[i].originalAmount * 1)) {
                            logger.logError(`累计该商品合计金额大于原始值${$scope.dataList[i].originalAmount}`)
                            return false
                        }
                    }
                    return true
                }
                function calculateTax(amt, taxrate, isTax) {
                    let taxamount = 0
                    if (isTax === '1') {
                        // 含税
                        taxamount = parseFloat(globalFn.Div(globalFn.Mul(amt, taxrate), globalFn.Add(1, taxrate))).toFixed(2)
                        if (taxrate == '0.015') {
                            taxamount = parseFloat(globalFn.Mul(globalFn.Div(amt, 1.05), 0.015)).toFixed(2)
                        }
                    } else {
                        // 不含税
                        taxamount = parseFloat(globalFn.Mul(amt, taxrate)).toFixed(2)
                        if (taxrate == '0.015') {
                            taxamount = parseFloat(globalFn.Div(globalFn.Mul(amt, 0.015), 1.035)).toFixed(2)
                        }
                    }
                    return taxamount
                }
                // 单价数量金额改变
                $scope.unitAmountChange = (obj, attr, index) => {
                    const typeChange = {
                        // div 除  quantity 数量
                        quantity: function () {
                            if (!obj.taxRate && obj.taxRate !== 0) {
                                return
                            }
                            // 当数量为空的时候不计算
                            if (!obj.quantity || obj.quantity === '') {
                                return
                            }
                            // 有单价 计算金额 ，有金额 计算单价 默认含税标志为不含税，没有差额计算
                            if (obj.price) {
                                if ($scope.invoice.isTax == 1) {
                                    obj.amountIncludeTax = parseFloat(globalFn.Mul(obj.quantity, obj.priceIncludeTax)).toFixed(2)
                                    obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.amountIncludeTax, obj.taxRate, $scope.invoice.isTax))
                                    obj.amount = parseFloat(globalFn.Sub(obj.amountIncludeTax, obj.taxAmount)).toFixed(2)
                                } else {
                                    obj.amount = parseFloat(globalFn.Mul(obj.quantity, obj.price)).toFixed(2)
                                    obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.amount, obj.taxRate, $scope.invoice.isTax))
                                    obj.amountIncludeTax = parseFloat(globalFn.Add(obj.amount, obj.taxAmount)).toFixed(2)
                                }
                            } else if (obj.amount && obj.quantity != 0 && obj.quantity) {
                                // 没有单价有金额 反算单价
                                obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 15) * 1
                                obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.amount, obj.taxRate, $scope.invoice.isTax))
                                obj.amountIncludeTax = parseFloat(globalFn.Add(obj.amount, obj.taxAmount)).toFixed(2)
                                obj.priceIncludeTax = globalFn.cutOutPnumber(globalFn.Div(obj.amountIncludeTax, obj.quantity), 15) * 1
                            }
                            if (!isAmount(obj.amount)) {
                                obj.quantity = prevData.quantity
                                obj.priceIncludeTax = prevData.priceIncludeTax
                                obj.price = prevData.price
                                obj.taxrate = prevData.taxrate
                                obj.amount = prevData.amount
                                obj.amountIncludeTax = prevData.amountIncludeTax
                                obj.taxAmount = prevData.taxAmount
                                logger.logError('金额为负数，整数部分不能大于12个数字，小数部分不能大于2个数字')
                                return
                            }
                            // 再校验 是否大于原始值
                            if (!isOverOriginalValue()) {
                                obj.quantity = prevData.quantity
                                obj.priceIncludeTax = prevData.priceIncludeTax
                                obj.price = prevData.price
                                obj.taxrate = prevData.taxrate
                                obj.amount = prevData.amount
                                obj.amountIncludeTax = prevData.amountIncludeTax
                                obj.taxAmount = prevData.taxAmount
                            }
                        },
                        //不含税单价
                        price: function () {
                                if ((!obj.taxRate && obj.taxRate !== 0) || !isPriceSetable(obj.price)) {
                                    return
                                }
                                // 有数量就算不含税金额、价税合计
                                if (obj.quantity) {
                                    obj.amount = globalFn.Mul(obj.quantity, obj.price).toFixed(2)
                                    obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.amount, obj.taxRate, $scope.invoice.isTax))
                                    obj.amountIncludeTax = parseFloat(globalFn.Add(obj.amount, obj.taxAmount)).toFixed(2)
                                    obj.priceIncludeTax = globalFn.cutOutPnumber(globalFn.Div(obj.amountIncludeTax, obj.quantity), 15)
                                } else if (obj.amount && obj.price != 0 && obj.price) {
                                    // 有不含税金额没有数量，反算数量，税额
                                    obj.quantity = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.price), 15)
                                    obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.amount, obj.taxRate, $scope.invoice.isTax))
                                    obj.amountIncludeTax = parseFloat(globalFn.Add(obj.amount, obj.taxAmount)).toFixed(2)
                                    obj.priceIncludeTax = globalFn.cutOutPnumber(globalFn.Div(obj.amountIncludeTax, obj.quantity), 15)
                                } else {
                                    if (obj.price === '' || obj.price === null) {
                                        obj.priceIncludeTax = obj.price
                                    } else {
                                        obj.priceIncludeTax = globalFn.cutOutPnumber(globalFn.Mul(obj.price, globalFn.Add(1, obj.taxRate)), 15)
                                    }
                                }
                                if (!isAmount(obj.amount)) {
                                    obj.quantity = prevData.quantity
                                    obj.priceIncludeTax = prevData.priceIncludeTax
                                    obj.price = prevData.price
                                    obj.taxrate = prevData.taxrate
                                    obj.amount = prevData.amount
                                    obj.amountIncludeTax = prevData.amountIncludeTax
                                    obj.taxAmount = prevData.taxAmount
                                    logger.logError('金额为负数，整数部分不能大于12个数字，小数部分不能大于2个数字')
                                    return
                                }
                                if (!isOverOriginalValue()) {
                                    // 超出原始值 默认一个值
                                    obj.quantity = prevData.quantity
                                    obj.priceIncludeTax = prevData.priceIncludeTax
                                    obj.price = prevData.price
                                    obj.taxrate = prevData.taxrate
                                    obj.amount = prevData.amount
                                    obj.amountIncludeTax = prevData.amountIncludeTax
                                    obj.taxAmount = prevData.taxAmount
                                }
                            },
                        //含税单价
                        priceIncludeTax: function () {
                            if ((!obj.taxRate && obj.taxRate !== 0) || !isPriceSetable(obj.priceIncludeTax)) {
                                return
                            }
                            // 有数量就算不含税金额、价税合计
                            if (obj.quantity) {
                                obj.amountIncludeTax = globalFn.Mul(obj.quantity, obj.priceIncludeTax).toFixed(2)
                                obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.amountIncludeTax, obj.taxRate, $scope.invoice.isTax))
                                obj.amount = parseFloat(globalFn.Sub(obj.amountIncludeTax, obj.taxAmount)).toFixed(2)
                                obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 15)
                            } else if (obj.amountIncludeTax && obj.priceIncludeTax != 0 && obj.priceIncludeTax) {
                                // 有价税合计 没有数量 反算数量
                                obj.quantity = globalFn.cutOutPnumber(globalFn.Div(obj.amountIncludeTax, obj.priceIncludeTax), 15)
                                obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.amountIncludeTax, obj.taxRate, $scope.invoice.isTax))
                                obj.amount = parseFloat(globalFn.Sub(obj.amountIncludeTax, obj.taxAmount)).toFixed(2)
                                obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 15)
                            } else {
                                if (obj.priceIncludeTax === '' || obj.priceIncludeTax === null) {
                                    obj.price = obj.priceIncludeTax
                                } else {
                                    obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.priceIncludeTax, globalFn.Add(1, obj.taxRate)), 15)
                                }
                            }
                            if (!isAmount(obj.amount)) {
                                obj.quantity = prevData.quantity
                                obj.priceIncludeTax = prevData.priceIncludeTax
                                obj.price = prevData.price
                                obj.taxrate = prevData.taxrate
                                obj.amount = prevData.amount
                                obj.amountIncludeTax = prevData.amountIncludeTax
                                obj.taxAmount = prevData.taxAmount
                                logger.logError('金额为负数，整数部分不能大于12个数字，小数部分不能大于2个数字')
                                return
                            }
                            if (!isOverOriginalValue()) {
                                // 超出原始值 默认一个值
                                obj.quantity = prevData.quantity
                                obj.priceIncludeTax = prevData.priceIncludeTax
                                obj.price = prevData.price
                                obj.taxrate = prevData.taxrate
                                obj.amount = prevData.amount
                                obj.amountIncludeTax = prevData.amountIncludeTax
                                obj.taxAmount = prevData.taxAmount
                            }
                        },
                        //不含税金额
                        amount: function () {
                            $scope.limitTwoDecimal(obj, attr)
                            let isRed
                            if (obj.amount < 0) {
                                isRed = 1
                            }
                            if ((!obj.taxRate && obj.taxRate !== 0) || !isAmountSetable(obj.amount, isRed)) {
                                return
                            }
                            if (!isAmount(obj.amount)) {
                                obj.quantity = prevData.quantity
                                obj.priceIncludeTax = prevData.priceIncludeTax
                                obj.price = prevData.price
                                obj.taxrate = prevData.taxrate
                                obj.amount = prevData.amount
                                obj.amountIncludeTax = prevData.amountIncludeTax
                                obj.taxAmount = prevData.taxAmount
                                logger.logError('金额为负数，整数部分不能大于12个数字，小数部分不能大于2个数字')
                                return
                            }
                            if (!isOverOriginalValue()) {
                                // 超出原始值 默认一个值
                                obj.quantity = prevData.quantity
                                obj.priceIncludeTax = prevData.priceIncludeTax
                                obj.price = prevData.price
                                obj.taxrate = prevData.taxrate
                                obj.amount = prevData.amount
                                obj.amountIncludeTax = prevData.amountIncludeTax
                                obj.taxAmount = prevData.taxAmount
                                return
                            }
                            if (!obj.amount || obj.amount === '-') {
                                return
                            }
                            // 计算税额
                            obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.amount, obj.taxRate, $scope.invoice.isTax))
                            // 价税合计
                            obj.amountIncludeTax = globalFn.Add(obj.amount, obj.taxAmount)
                            // 没有数量有单价 反算数量
                            if (obj.price && obj.price != 0 && !obj.quantity) {
                                obj.quantity = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.price), 15)
                                // 没有单价有数量 反算单价
                            } else if (obj.quantity && obj.quantity != 0 && !obj.priceIncludeTax) {
                                obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 15)
                                obj.priceIncludeTax = globalFn.cutOutPnumber(globalFn.Div(obj.amountIncludeTax, obj.quantity), 15)
                                // 有数量 也有 单价 反算数量
                            } else if (obj.quantity && obj.quantity != 0 && obj.priceIncludeTax) {
                                obj.quantity = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.price), 15)
                            }
                        },
                        //含税金额
                        amountIncludeTax: function () {
                            $scope.limitTwoDecimal(obj, attr)
                            let isRed
                            if (obj.amountIncludeTax < 0) {
                                isRed = 1
                            }
                            if ((!obj.taxRate && obj.taxRate !== 0) || !isAmountSetable(obj.amountIncludeTax, isRed)) {
                                return
                            }
                            if (!obj.amountIncludeTax || obj.amountIncludeTax === '-') {
                                return
                            }
                            obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.amountIncludeTax, obj.taxRate, $scope.invoice.isTax))
                            obj.amount = parseFloat(globalFn.Sub(obj.amountIncludeTax, obj.taxAmount)).toFixed(2)
                            // 没有数量有单价 反算数量
                            if (obj.priceIncludeTax && obj.priceIncludeTax != 0 && !obj.quantity) {
                                obj.quantity = globalFn.cutOutPnumber(globalFn.Div(obj.amountIncludeTax, obj.priceIncludeTax), 15)
                                obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 15)
                                // 没有单价有数量 反算单价
                            } else if (obj.quantity && obj.quantity != 0 && !obj.priceIncludeTax) {
                                obj.priceIncludeTax = globalFn.cutOutPnumber(globalFn.Div(obj.amountIncludeTax, obj.quantity), 15)
                                if (obj.priceIncludeTax === Infinity) {
                                    obj.priceIncludeTax = ''
                                } else {
                                    obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 15)
                                }
                                // 有数量 也有 单价 反算数量
                            } else if (obj.quantity && obj.quantity != 0 && obj.priceIncludeTax) {
                                obj.quantity = globalFn.cutOutPnumber(globalFn.Div(obj.amountIncludeTax, obj.priceIncludeTax), 15)
                            }
                            if (!isAmount(obj.amount)) {
                                obj.quantity = prevData.quantity
                                obj.priceIncludeTax = prevData.priceIncludeTax
                                obj.price = prevData.price
                                obj.taxrate = prevData.taxrate
                                obj.amount = prevData.amount
                                obj.amountIncludeTax = prevData.amountIncludeTax
                                obj.taxAmount = prevData.taxAmount
                                logger.logError('金额为负数，整数部分不能大于12个数字，小数部分不能大于2个数字')
                                return
                            }
                            if (!isOverOriginalValue()) {
                                // 超出原始值 默认一个值
                                obj.quantity = prevData.quantity
                                obj.priceIncludeTax = prevData.priceIncludeTax
                                obj.price = prevData.price
                                obj.taxrate = prevData.taxrate
                                obj.amount = prevData.amount
                                obj.amountIncludeTax = prevData.amountIncludeTax
                                obj.taxAmount = prevData.taxAmount
                                return
                            }
                        },
                    }
                    typeChange[attr]()
                    totalCalculation($scope.dataList)
                }
                $scope.changeRedReason = function () {
                    if($scope.invoice.vatUsageCode=='03' && $scope.invoice.exciseUsageCode=='00' && $scope.invoice.entryStatus=='00'){
                        $scope.isDel = false
                        $scope.isEdit = false
                        $scope.isQuantity = false
                    }
                    if($scope.invoice.redReason == '1' && ($scope.invoice.vatUsageCode=='01' || $scope.invoice.exciseUsageCode=='01' || $scope.invoice.entryStatus=='01')){
                        $scope.isDel = true
                        $scope.isEdit = false
                        $scope.isQuantity = true
                        reduction()
                    }
                    if($scope.invoice.redReason == '2' && ($scope.invoice.vatUsageCode=='01' || $scope.invoice.exciseUsageCode=='01' || $scope.invoice.entryStatus=='01')){
                        $scope.isDel = false
                        $scope.isEdit = false
                        $scope.isQuantity = false
                        reduction()
                    }
                    if($scope.invoice.redReason == '3' && ($scope.invoice.vatUsageCode=='01' || $scope.invoice.exciseUsageCode=='01' || $scope.invoice.entryStatus=='01')){
                        $scope.isDel = true
                        $scope.isEdit = true
                        $scope.isQuantity = true
                        reduction()
                    }
                    if($scope.invoice.redReason == '4' && ($scope.invoice.vatUsageCode=='01' || $scope.invoice.exciseUsageCode=='01' || $scope.invoice.entryStatus=='01')){
                        $scope.isDel = true
                        $scope.isEdit = true
                        $scope.isQuantity = false
                    }
                    if($scope.dataList.length === 1){
                        $scope.isDel = false
                    }
                }
                function reduction() {
                    if(!$scope.dataList[0].quantity){
                        $scope.dataList.forEach((item)=>{
                            item.quantity = item.originalQuantity
                            item.price = item.originalPrice
                            item.priceIncludeTax = item.originalPriceIncludeTax
                            item.amount = item.originalAmount
                            item.amountIncludeTax = item.originalAmountIncludeTax
                            item.taxAmount = item.originalTaxAmount
                        })
                    }
                }
                $scope.delData = []
                // 发票明细行  删除数据存储
                $scope.deleteBill = function (item) {
                    item.state = 0 //state (integer, optional): 1-有效 0-已删除 ,
                    $scope.delData.push(item)
                    $scope.dataList = $scope.dataList.filter((x) => x !== item);
                    $scope.isAdd = false
                    if($scope.dataList.length === 1){
                        $scope.isDel = false
                    }
                    totalCalculation($scope.dataList)
                }
                // 发票明细行  新增数据
                $scope.addDetailList = function () {
                    let newData  = $scope.delData[0]
                    newData.state = 1
                    $scope.dataList.push(newData)
                    $scope.isDel = true
                    $scope.delData = $scope.delData.filter((x) => x !== newData);
                    if($scope.delData.length === 0){
                        $scope.isAdd = true
                    }
                    totalCalculation($scope.dataList)
                }
                // 更新 合计 金额 税额
                function totalCalculation(billList) {
                    $scope.totalAmount = 0
                    $scope.totalTaxAmount = 0
                    $scope.totalAdValoremTotal = 0
                    angular.forEach(billList, (item, index) => {
                        $scope.totalAmount = globalFn.Add($scope.totalAmount, item.amount)
                        $scope.totalTaxAmount = globalFn.Add($scope.totalTaxAmount, item.taxAmount)
                        $scope.totalAdValoremTotal = globalFn.Add($scope.totalAmount, $scope.totalTaxAmount)
                    })
                    $scope.chineseAmtTotal = globalFn.digitUppercase($scope.totalAdValoremTotal)
                    $scope.invoice.redRevokeAmt = Number($scope.totalAmount)
                    $scope.invoice.redRevokeTaxAmt = Number($scope.totalTaxAmount)
                    // $scope.invoice.adValoremTotal = Number($scope.totalAdValoremTotal)
                }
                // 新增时 - 还原
                $scope.addReductionDetailList = ()=>{
                    $scope.delData = []
                    $scope.isAdd = true
                    httpRequest.post_getRedConfirmBody({confirmId:$scope.newConfirmId}).then((res) => {
                        $scope.dataList = res.data.value.ovatTax4RedConfirmDetails
                        dataFormat()
                    })
                }
                // 编辑时 - 还原
                $scope.reductionDetailList = () =>{
                    $scope.delData = []
                    $scope.isAdd = true
                    httpRequest.post_initRedConfirmDetail($scope.invoice.confirmId).then((res) => {
                        $scope.dataList = res.data.value
                        dataFormat()
                    })
                }

                // 返回上一步
                $scope.returnReselect = () => {
                    if($scope.invoice.workflowStatus == '-2'){
                        httpRequest.post_tax4RedConfirmDelete({confirmId:$scope.invoice.confirmId}).then((res) => {
                            console.log(res)
                        })
                    }
                    $scope.changeState('selectTicketTab')
                }
                // 暂存
                $scope.storage = () => {
                    const result1 = $scope.invoice.confirmMail && utils.regExpTestEmail($scope.invoice.confirmMail)
                    const result2 = $scope.invoice.sendMail && utils.regExpTestEmail($scope.invoice.sendMail)
                    if ($scope.invoice.confirmMail && !result1) {
                        logger.logError('邮箱格式不正确')
                        return
                    }
                    if ($scope.invoice.sendMail && !result2) {
                        logger.logError('邮箱格式不正确')
                        return
                    }
                    if($scope.invoice.businessBaseDTO){
                        $scope.invoice.businessBaseDTO.needSave = true//业务信息 需要储存
                    }
                    httpRequest.post_updateOvatTax4RedConfirm($scope.invoice).then((res) => {
                        logger.logSuccess(res.data.value)
                        $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.list')
                    })
                }
                // 提交 - 先暂存 后提交 - 判断是否有审批流 - 无审批流 调用上传税局的接口 后直接跳转页面查询详情展示结果 /  有审批流 直接跳转页面查询详情展示结果
                $scope.submit = () => {
                    const result1 = $scope.invoice.confirmMail && utils.regExpTestEmail($scope.invoice.confirmMail)
                    const result2 = $scope.invoice.sendMail && utils.regExpTestEmail($scope.invoice.sendMail)
                    if ($scope.invoice.confirmMail && !result1) {
                        logger.logError('邮箱格式不正确')
                        return
                    }
                    if ($scope.invoice.sendMail && !result2) {
                        logger.logError('邮箱格式不正确')
                        return
                    }
                    if($scope.invoice.businessBaseDTO){
                        $scope.invoice.businessBaseDTO.needSave = true//业务信息 需要储存
                    }
                    // 暂存
                    httpRequest.post_updateOvatTax4RedConfirm($scope.invoice).then((res) => {
                        // 提交
                        httpRequest.post_submitRedConfirm({confirmId:$scope.invoice.confirmId}).then((res) => {
                            if(!$scope.approveStatu){ // 无审批流  上传税局
                                let ukeyList = $scope.ukeyList.filter(u => {
                                    return u.ukeyId == $scope.invoice.ukeyId;
                                });
                                let mes = ''
                                if(ukeyList[0].manageType === '6' && $scope.invoice.confirmApplyFlag === 'Y' && $scope.invoice.confirmStatus === '01'){
                                    mes = '本次红字确认单上传税局申请成功后，将直接生成红字发票，请确定是否继续提交?'
                                }
                                if(ukeyList[0].manageType === '6' && $scope.invoice.confirmApplyFlag === 'Y' && ($scope.invoice.confirmStatus === '02' || $scope.invoice.confirmStatus === '03')){
                                    mes = '本次红字确认单上传税局申请成功后，需经对方确认，确认方确认后将直接生成红字发票，请确定是否继续提交?'
                                }
                                if(mes){
                                    sweetalert.confirm('温馨提示', mes).then(() => {
                                        realSubmit()
                                    })
                                }else {
                                    realSubmit()
                                }
                            }else {
                                logger.logSuccess(res.data.value)
                                let data = {
                                    confirmId:$scope.invoice.confirmId,
                                    ukeyId:$scope.invoice.ukeyId,
                                }
                                $scope.changeState('submitSuccessTab',data)
                            }
                        })
                    })
                }
                function realSubmit() {
                    httpRequest.post_uploadRedConfirm($scope.invoice.confirmId, $scope.invoice.ukeyId).then((res1) => {
                        if(res1.data.msgCode === 2002 || res1.data.msgCode === 2003){
                            logger.logSuccess(res1.data.message)
                            $uibModal.open({
                                template: authenticationModalTemplate,
                                controller: 'authenticationModalCtrl',
                                backdrop: 'static',
                                openedClass: 'mod-modal mod-modal-lg',
                                resolve: {
                                    items1() {
                                        return {
                                            authorizeId: res1.data.emsg,
                                            mobile: res1.data.message.substring(10),
                                        }
                                    },
                                },
                            })
                        }else if(res1.data.msgCode === -99998) {
                            $uibModal.open({
                                template: certificationModalTemplate,
                                controller: 'certificationModalCtrl',
                                backdrop: 'static',
                                openedClass: 'mod-modal mod-modal-lg',
                                resolve: {
                                    items1() {
                                        return { authorizeId: res1.data.emsg }
                                    },
                                },
                            })
                        }else {
                            logger.logSuccess(res1.data.value)
                            let data = {
                                confirmId:$scope.invoice.confirmId,
                                ukeyId:$scope.invoice.ukeyId,
                            }
                            $scope.changeState('submitSuccessTab',data)
                        }
                    })
                }
            },
        ],
        link(scope) {},
    }
}

inforConfirm.$inject = ['$uibModal', 'httpRequest', 'logger', 'inforConfirmFieldConfig', '$stateParams', '$state', 'sweetalert']



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/directive/inforConfirm/inforConfirm.js